export default {
      id: "deco_alu-usage",
      viewBox: "0 0 225 205",
      url: "../dist/images/" + "sprite.svg#deco_alu-usage",
      toString: function () {
        return this.url;
      }
    }